<template>
  <landing-page
    label="bivalentVaccine.booking"
    description="bivalentVaccine.bivalentVaccine"
    labelColor="#603813"
    descColor="#603813"
    labelFontSize="text-7xl"
    descFontSize="text-5xl font-bold"
    textWidth="30vw"
    :eggImgObj="{ componentName: 'bivalentVaccine', imgName: 'bivalentVaccineIntro', imgFormat: 'svg', margin: 'mr-12' }"
    :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconBrownRight', imgFormat: 'svg' }"
    class="mb-10"
  />
</template>

<script setup lang="ts">
import { useBivalentVaccineStore } from "@/stores/bivalentVaccine";
import { useCommonStore } from "@/stores/common";

import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const bivalentVaccineStore = useBivalentVaccineStore();
const commonStore = useCommonStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>